import LastActiveFilter from "./LastActiveFilter";

export default LastActiveFilter;
